import useFeatureFlagValue from '@/components/analytics/hooks/useFeatureFlagValue';

/**
 * PD-7076: temporary rollout for the city-list Dine Now banner.
 * The lasting gate is the city's `walkInsEnabled`.
 *
 * @see https://firsttable.atlassian.net/browse/PD-7076
 * @see https://app.growthbook.io/features/PD-7076:exp:list:dine_now_banner:web
 */
export const pd7076DineNowBannerWeb = 'PD-7076:exp:list:dine_now_banner:web';

export default function useDineNowBanner(): boolean {
  return useFeatureFlagValue(pd7076DineNowBannerWeb, false) === true;
}
